<script>
import Layout from '@layout/main'
import SectionRowItem from './components/SectionRowItem'
import SectionVideoItem from './components/SectionVideoItem'
import setWindowHistory from '@utils/window-history'
import { getDefaultBrand } from '@utils/zerone-get-default'
import { brandOptions } from '@utils/zerone-options'

const DEFAULT_SEARCH = {
  brand: '',
  month: '',
  query: '',
}

export default {
  page() {
    return {
      title: `影片專區`,
    }
  },
  components: {
    Layout,
    SectionRowItem,
    SectionVideoItem,
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      },
    },
    pagination: {
      type: Object,
      default: () => {
        return {}
      },
    },
    topList: {
      type: Array,
      default: () => {
        return []
      },
    },
    brandOptions: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      type: 'viedo',
      searchData: {
        brand: getDefaultBrand(this.$route.query.brand, this.brandOptions) || DEFAULT_SEARCH.brand,
        month: this.$route.query.month || DEFAULT_SEARCH.month,
        query: this.$route.query.query || DEFAULT_SEARCH.query,
      },
      videoList: this.list || [],
      videoPagination: this.pagination || {},
      loadingFetchVideoList: false,
      isShowFilterMenu: false,
      searchList: [
        {
          width: '28%',
          type: 'select',
          placeholder: '所有品牌',
          name: 'brand',
          options: brandOptions(this.brandOptions),
        },
        {
          width: '20%',
          type: 'month',
          placeholder: '不限時間',
          name: 'month',
          clearable: true,
        },
        {
          type: 'text',
          placeholder: '請輸入關鍵字',
          name: 'query',
        },
      ],
    }
  },
  computed: {
    formattedList() {
      return this.videoList.map((item) => ({
        title: item.title,
        publish_up: item.publish_up,
        description: item.description,
        brands: item.brands[0],
        to: {
          name: 'video-item',
          params: {
            brandAlias: this.$route.query.brand || (item.brands[0] && item.brands[0].alias),
            categoryAlias: item.category_alias,
            videoAlias: item.alias,
          },
        },
        videoId: this.youtubeId(item.extrafields.youtube_url.value),
      }))
    },

    // formattedTopList() {
    //   const list = this.topList.map((item)=>({
    //     title: item.title,
    //     publish_up: item.publish_up,
    //     description: item.description,
    //     introtext: item.introtext,
    //     brands:item.brands[0],
    //     to: {
    //       name: 'video-item',
    //       params: {
    //         brandAlias: this.$route.query.brand || item.brands[0] && item.brands[0].alias,
    //         categoryAlias: item.category_alias,
    //         videoAlias: item.alias,
    //       },
    //     },
    //     videoId: item.extrafields.video_url.value,
    //     // isdealer: item.extrafields.dealer_only.value === "1"
    //   }))

    //   // 置頂只顯示2則
    //   if (list.length > 2) {
    //     list.length = 2
    //     return list
    //   }
    //   return list
    // },
    hasFilter() {
      if (Object.keys(this.$route.query).length) {
        return Object.keys(this.$route.query).some((key) => {
          return this.$route.query[key] !== undefined
        })
      } else {
        return false
      }
    },
  },
  methods: {
    onSubmit(data) {
      setWindowHistory({
        query: {
          // ...this.$route.query,
          page: 1,
        },
      })
      this.tryToFetchVideoList({
        storeParams: {
          // ...this.$route.params,
          page: 1,
        },
      })
    },
    onChangePagination(page) {
      this.tryToFetchVideoList({
        storeParams: {
          // ...this.$route.params,
          page,
        },
      }).then(() => {
        const url = new URL(window.location)
        let params = url.searchParams
        if (params.has('page')) {
          this.$scrollToElement({
            $el: this.$refs['sectionList'],
            offset: 270,
          })
        }
      })
    },
    async tryToFetchVideoList({ storeParams } = {}) {
      this.loadingFetchVideoList = true
      const params = {
        // ...this.searchData,
        search_date: this.searchData.month,
        brand_alias: this.searchData.brand ? [this.searchData.brand] : '',
        search: this.searchData.query,
        page: this.$route.query.page,
        limit: 9,
        ...storeParams,
      }
      await this.$store
        .dispatch('article/fetchList', {
          contentAlias: 'video',
          params,
        })
        .then((response) => {
          this.videoList = response.items
          this.videoPagination = response.pagination
        })
        .finally(() => {
          this.loadingFetchVideoList = false
        })
    },
    onClearSearch() {
      Object.keys(this.searchData).forEach((key) => {
        this.searchData[key] = undefined
      })

      setWindowHistory({
        query: {
          ...this.$route.query,
          ...this.searchData,
          page: 1,
        },
      })
      this.tryToFetchVideoList({
        storeParams: {
          page: 1,
        },
      })
    },
    youtubeId(id) {
      if (id) {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/
        const match = id.match(regExp)
        return match && match[7].length === 11 ? match[7] : false
      }

      return ''
    },
    // formattedVideoId(id) {
    //   if(id.includes('=')){
    //     return id.split('=')[1]
    //   }else {
    //     return id.split('/')[id.split('/').length - 1]
    //   }
    // },
    onOpenFilter(status) {
      this.isShowFilterMenu = status
    },
  },
}
</script>
<template>
  <Layout>
    <BaseBanner title="影片專區" :image="require('@assets/images/video/index_banner.png')" custom-class="isStyleWhite" @openFilter="onOpenFilter(!isShowFilterMenu)" />
    <template v-if="hasFilter || list.length || topList.length">
      <SectionRowItem v-if="topList.length" :list="topList" />
      <div class="SectionNewsItem section">
        <div class="container">
          <BaseSearchBar v-model="searchData" :list="searchList" submit-text="搜尋影片" :is-show-filter="isShowFilterMenu" @search="onSubmit" @openFilter="onOpenFilter(false)" />
          <div v-if="videoList.length" ref="sectionList">
            <SectionVideoItem v-if="hasFilter || videoList.length" :list="formattedList" :pagination="videoPagination" @clearSearch="onClearSearch" @changePagination="onChangePagination" />
          </div>
          <BaseNull v-else is-search-null @clearSearch="onClearSearch" />
        </div>
      </div>
    </template>
    <div v-else class="container section ">
      <BaseNull content="<p class='my-0'>目前此頁面尚無建置資料</p>"> </BaseNull>
    </div>
  </Layout>
</template>
